<script>
import { onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import Auth from "@aws-amplify/auth";
import { initializeLogData } from "@/utils/logUtils"; // 追加
import { ADMIN_COMPANY_CODE } from "@/constants";
import { setupAutoLogout } from "@/utils/autoLogout";

export default {
  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();

    async function signIn() {
      const currentUserInfo = await Auth.currentUserInfo();
      if (currentUserInfo) {
        const currentSession = await Auth.currentSession();
        await setUserSessionInfo(currentSession);
        
        // CompanyCodeを取得
        const companyCode = currentSession.idToken.payload.profile;
        
        // CompanyCodeが管理者コードの場合は管理者画面に遷移
        if (companyCode === ADMIN_COMPANY_CODE) {
          router.replace("/admin");
        } else {
          // 通常ユーザーは元のページまたはデフォルトページに遷移
          router.replace(route.query.nextPath || "/");
        }
      } else {
        store.dispatch("signIn");
      }
    }

    async function setUserSessionInfo(session) {
      store.dispatch("setSession", session);
      store.dispatch("setIDToken", session.getIdToken().getJwtToken());
      store.dispatch("setIsAuthenticated", true);
      store.dispatch("setEmail", session.idToken.payload.email);
      store.dispatch("setGivenName", session.idToken.payload.given_name);
      store.dispatch("setFamilyName", session.idToken.payload.family_name);
      store.dispatch("setCompanyCode", session.idToken.payload.profile);
      store.dispatch("setCompanyName", session.idToken.payload.locale);
      store.dispatch("setUserId", session.idToken.payload.preferred_username);

      // ログデータを作成してストアに保存
      const logData = await initializeLogData(store);
      store.commit("setLogData", logData.value);

      // 自動ログアウト機能をセットアップ（ログイン成功後）
      await setupAutoLogout();
    }

    onMounted(function () {
      signIn();
    });

    return {
      signIn,
      setUserSessionInfo,
    };
  },
};
</script>

<template><div></div></template>
<style></style>
